module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/7b80fcafc9fc92e3bd91a895acf4ca7a.gif";